import type { AmountObject } from '@george-labs.com/design-system/types/components/Input/AmountInput';

export const pickAmountValue = (
    _processedValue: string,
    { value }: Pick<AmountObject, 'value'>,
): AmountObject['value'] => value;

export const fallbackToEmptyString = (
    processedValue: string,
    { value }: Pick<AmountObject, 'value'>,
): AmountObject['value'] | string => (processedValue ? value : '');

export const convertToNumberOrNull = (
    processedValue: string,
    { value }: Pick<AmountObject, 'value'>,
): number | null => {
    if (processedValue === '') {
        return null;
    }
    if (typeof value === 'string') {
        return parseInt(value, 10);
    }
    return value;
};
